export default __webpack_public_path__ + "static/media/ideal-for-renovations.e4f97a5d.svg";